import './PullmanSanAndreasTermsAndConditions.css';

import { AppData } from '../../../../services';
import GoogleMapReact from 'google-map-react';
import PullmanBanners from '../components/PullmanBanners';
import React from 'react';
import ThemeSixOfficeSection from '../components/ThemeSixOfficeSection';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeThreeTitle from '../../ThemeThree/common/ThemeThreeTitle';

const AnyReactComponent = ({ img }) => (
  <div>
    <img
      style={{
        display: 'inline-block',
        width: '20px',
      }}
      alt=""
      src={img}
    />
  </div>
);

function PullmanSanAndreasTermsAndConditions({ home }) {
  const operator = home.operator ? home.operator : '';

  const createMarkup = data => {
    return { __html: data };
  };

  return (
    <div className="pullman-san-andreas-contact">
      <PullmanBanners
        bgImage={getIcons('contactBanner')}
        text={'Términos y condiciones'}
        textPosition={'center'}
      />
      <KuposHelmet />
      <div className="new-container">
        <ThemeThreeTitle operator={operator} title="Términos y condiciones" />

        <div
          dangerouslySetInnerHTML={createMarkup(
            operator && operator.privacy_policy ? operator.terms : '',
          )}
          className="lh-1-3 terms-and-conditions"
          style={{ fontSize: '13px' }}
        />
      </div>
    </div>
  );
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

export default connect(mapStateToProps)(PullmanSanAndreasTermsAndConditions);



// WEBPACK FOOTER //
// ./src/features/themes/theme6/PullmanSanAndreasPage/PullmanSanAndreasTermsAndConditions.js